const descriptions = {
  chaptersTitle: {
    id: 'course-authoring.textbooks.chapters.title',
    defaultMessage: '{count} PDF chapters',
    description: 'Title for the list of PDF chapters',
  },
  buttonView: {
    id: 'course-authoring.textbooks.button.view',
    defaultMessage: 'View the PDF live',
    description: 'Text for the button to view the PDF live',
  },
  buttonViewAlt: {
    id: 'course-authoring.textbooks.button.view.alt',
    defaultMessage: 'textbook-view-button',
    description: 'Alt text for the view button',
  },
  buttonEdit: {
    id: 'course-authoring.textbooks.button.edit',
    defaultMessage: 'Edit',
    description: 'Text for the edit button',
  },
  buttonEditAlt: {
    id: 'course-authoring.textbooks.button.edit.alt',
    defaultMessage: 'textbook-edit-button',
    description: 'Alt text for the edit button',
  },
  buttonDelete: {
    id: 'course-authoring.textbooks.button.delete',
    defaultMessage: 'Delete',
    description: 'Text for the delete button',
  },
  buttonDeleteAlt: {
    id: 'course-authoring.textbooks.button.delete.alt',
    defaultMessage: 'textbook-delete-button',
    description: 'Alt text for the delete button',
  },
  deleteModalTitle: {
    id: 'course-authoring.textbooks.form.delete-modal.title',
    defaultMessage: 'Delete “{textbookTitle}”?',
    description: 'Title for the delete modal',
  },
  deleteModalDescription: {
    id: 'course-authoring.textbooks.form.delete-modal.description',
    defaultMessage: 'Deleting a textbook cannot be undone and once deleted any reference to it in your courseware\'s navigation will also be removed.',
    description: 'Description for the delete modal',
  },
};

export default descriptions;
